export default __webpack_public_path__ + "static/media/_IMG2924.d94a6748.jpg";